var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
export function ModalConfirmacao(_a) {
    var open = _a.open, onCancel = _a.onCancel, onConfirm = _a.onConfirm, submitting = _a.submitting, title = _a.title, titleColor = _a.titleColor, message = _a.message, confirmText = _a.confirmText, submittingText = _a.submittingText, confirmColor = _a.confirmColor, confirmHoverColor = _a.confirmHoverColor, icon = _a.icon;
    return (_jsxs(Dialog, __assign({ open: open, fullWidth: true, disableEscapeKeyDown: true, PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsx(Box, __assign({ sx: { p: 2.5, pb: 0, borderBottom: 'none' } }, { children: _jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 800, color: titleColor, fontSize: '1.05rem' } }, { children: title })) })), _jsx(DialogContent, __assign({ sx: { pt: 1.5, pb: 2 } }, { children: _jsx(Typography, __assign({ variant: 'body2', sx: { color: '#6B7280', lineHeight: 1.6 } }, { children: message })) })), _jsxs(DialogActions, __assign({ sx: {
                    p: 2,
                    pt: 0,
                    gap: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                } }, { children: [_jsx(Button, __assign({ variant: 'outlined', onClick: onCancel, disabled: submitting, sx: {
                            fontWeight: 700,
                            flex: 1,
                            color: '#4B5563',
                            borderColor: '#D1D5DB',
                            backgroundColor: '#FFFFFF',
                            '&:hover': { backgroundColor: '#F9FAFB', borderColor: '#D1D5DB' },
                        } }, { children: "CANCELAR" })), _jsx(Button, __assign({ variant: 'contained', onClick: onConfirm, disabled: submitting, disableElevation: true, startIcon: submitting ? _jsx(CircularProgress, { size: 16, color: 'inherit' }) : icon, sx: {
                            fontWeight: 700,
                            flex: 1,
                            backgroundColor: confirmColor,
                            color: '#fff',
                            '&:hover': { backgroundColor: confirmHoverColor },
                            '&:disabled': { opacity: 0.65 },
                        } }, { children: submitting ? submittingText : confirmText }))] }))] })));
}
